export const DEFAULT_DATA_GRID_HEADER_HEIGHT = 40;
export const DEFAULT_DATA_GRID_ROW_HEIGHT = 40;
